import React from 'react';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import classes from 'components/common/Tables/Cells/TooltipCell/TooltipCell.module.scss';

export const TooltipCell = ({ value }: { value: React.ReactNode }) => {
    return (
        <div className={classes.overflow}>
            <CustomizedTooltip
                tooltipContent={value}
                triggerElement={<div className={classes.ellipsis}>{value}</div>}
            />
        </div>
    );
};
